export default {"src":"/_next/static/media/Basket-Blue.3b1b5baf.svg","height":19,"width":23};